import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { MenuItem, MessageService } from 'primeng/api';
import { first, shareReplay } from 'rxjs';
import { ActivityRecordService } from 'src/app/services/activity-record.service';
import { AppLoaderService } from 'src/app/services/app-loader/app-loader.service';
import { CaoService } from 'src/app/services/cao.service';
import { CryptoJsService } from 'src/app/services/crypto-js.service';
import { DepartmentDashboardService } from 'src/app/services/department-dashboard.service';
import { IpAddressService } from 'src/app/services/ip-address.service';
import { VendorDashboardService } from 'src/app/services/vendor-dashboard.service';
import saveAs from 'file-saver';
import { BaseService } from 'src/app/services/common/base.service';

@Component({
  selector: 'app-e-sparsh-payment',
  templateUrl: './e-sparsh-payment.component.html',
  styleUrls: ['./e-sparsh-payment.component.scss'],
  providers: [DatePipe]
})
export class ESparshPaymentComponent implements OnInit {

  public selectedDivision: any;
  public divisonList: any = [];
  public selectedContractor: any;
  public contractorList: any = [];
  public showDetailTable: boolean = false;

  public userId: any;
  public date: any;
  public loading: boolean = false;

  public lotTableData: any = [];

  public subscriptions: any = []
  public subjectSub: any;

  public printGeneratedDate: any;
  public addDialog: boolean = false;
  public lotNo: any;
  public loading1: boolean = false;
  public appVerificationItems: MenuItem[];
  public selectedYear: any;

  public appDataLotWise: any = [];
  public miCertificateData: any = {};
  groupedVendors: any[] = [];
  filteredVendors: any[] = [];
  filterText: string = '';
  ipAddress: any = '000.000.000';

  selectedCasteToFilter: any = null;
  selectedSanctionToFilter: any = null;
  casteDespList: any = [];
  sanctionTypeList: any = [];

  constructor(
    private loader: AppLoaderService,
    private activityRecordService: ActivityRecordService,
    private deptDashBoardService: DepartmentDashboardService,
    private messageService: MessageService,
    // private route: ActivatedRoute,
    private cryptoJsService: CryptoJsService,
    private ipService: IpAddressService,
    private datePipe: DatePipe,
    // public cd: ChangeDetectorRef,
    // public router: Router,
    // private service: BaseService,
    private vendorService: VendorDashboardService,
    private caoService: CaoService, 
    private service: BaseService,
  ) { }

  ngOnInit(): void {
    this.getIP();
    this.date = this.datePipe.transform(new Date(), 'yyyy-MM-dd');
    // this.date = new Date();
    const token: any = JSON.parse(this.cryptoJsService.DecryptToken(sessionStorage.getItem('token')));    
    let payload = atob(token?.authToken?.split('.')[1]);
    this.userId = JSON.parse(payload)?.sub;

    this.loadDivison(this.userId);
    this.loadSanctionTypeList();
    
    // this.getAppStatusTypeList();

    this.appVerificationItems = [
      {
        label: 'Download excel', icon: 'pi pi-fw pi-download', command: () => {
          this.pfmsExportExcel(this.appDataLotWise, `${this.lotNo}_(${this.date})`);
        }
      },
    ];
  }

  loadSanctionTypeList(){
    setTimeout(() => {
      this.sanctionTypeList = [
        { label: 'Center & State Share Payment Amount', data: 'State_Center' },
        { label: 'Topup Amount', data: 'Topup'},
      ]
    }, 100);
  }

  onSelectDivision(){
    this.selectedContractor = null;
    this.showDetailTable = false;
    this.lotTableData = [];
    this.loadContractor(this.selectedDivision?.UserID);
  }

  loadDivison(userId) { 
    this.loader.start();
    let sub = this.vendorService
    .getDivisionMasterEPC(userId)
      .pipe(first())
      .subscribe({
        next: (data) => {
          this.loader.close();          
          if (data.length > 0) {
            this.divisonList = data;
          }
          else {
            this.divisonList = [];
            this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'Data Not Available' });
          }
        },
        error: (err) => {
          this.loader.close(); 
          this.divisonList = [];
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: err,
          });
        },
      });

    this.subscriptions.push(sub);
  }

  loadContractor(userId) { 
    this.loader.start();
    let sub = this.vendorService
    .getContractorMaster(userId)
      .pipe(first())
      .subscribe({
        next: (data) => {
          this.loader.close();          
          if (data.length > 0) {
            this.contractorList = data;
          }
          else {
            this.contractorList = [];
            this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'Data Not Available' });
          }
        },
        error: (err) => {
          this.loader.close(); 
          this.contractorList = [];
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: err,
          });
        },
      });

    this.subscriptions.push(sub);
  }

  onSelectContractor() {
    if (this.selectedContractor) {
      this.showDetailTable = true;
      this.lotTableData = [];
      this.loadData(this.selectedContractor?.ContractorCode, this.selectedDivision?.UserID);
    }
  }

  refreshTable() {
    if(this.selectedContractor){
      this.loadData(this.selectedContractor?.ContractorCode, this.selectedDivision?.UserID);
    }
  }

  loadData(contractorId, userId) {
    // this.loader.start();
    this.loading = true;
    let sub = this.deptDashBoardService
      .getAppsForLotPFMSEPC(contractorId, userId)
      .pipe(first())
      .subscribe({
        next: (data) => {
          // this.loader.close();
          this.loading = false;

          if (data.length > 0) {
            this.lotTableData = data;
          }
          else {
            this.lotTableData = [];

            this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'Data Not Available' });
          }

        },
        error: (err) => {
          this.loading = false;
          this.lotTableData = [];

          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: err,
          });
        },
      });

    this.subscriptions.push(sub);
  }

  ngOnDestroy() {
    this.subscriptions.forEach(sub => sub.unsubscribe());
    if (this.subjectSub) {
      this.subjectSub.unsubscribe();
    }
  }

  pmfsExport(row, status) {
    // this.printGeneratedDate = this.toISOLocal(new Date()).replace(/.\d+Z$/g, "");
    this.printGeneratedDate = this.datePipe.transform(new Date(), 'yyyy-MM-dd');
    this.addDialog = true;
    this.lotNo = row?.Lot_No;
    this.selectedYear = row?.FinYear
    // this.loader.start();
    this.loading1 = true;
    this.getLotDetails(row?.Lot_No);
    this.getLotCertificateData(row?.Lot_No, status);
  }

  getIP() {
    if (sessionStorage.getItem('ipAddress')) {
      this.ipAddress = JSON.parse(window.sessionStorage.getItem('ipAddress'));
    }else{
      this.ipService.getIPAddress().subscribe((res: any) => {
        this.ipAddress = res.ip;
        sessionStorage.setItem('ipAddress',JSON.stringify(this.ipAddress));
      });
    }
  }

  applyFilter(): void {
    if (!this.filterText) {
      this.filteredVendors = [...this.groupedVendors];
      return;
    }
    
    const filter = this.filterText.toLowerCase();
    this.filteredVendors = this.groupedVendors.filter(vendor => 
      vendor.vendorName.toLowerCase().includes(filter)
    );
  }

  getLotCertificateData(lotId, status){
    this.miCertificateData = {};
    if(status== ''){
      this.caoService.getDataForLotCertificate_EPC(lotId)
      .pipe(first())
      .subscribe({
        next: (data) => {
          this.miCertificateData = data[0];
          // this.activityRecordService.activityRecord(this.userId, 'Farmer Share to Farmer PFMS Export (ABY) Lot Certificate', lotId, new Date(), 'Success');
        },
        error: (err) => {
          this.messageService.add({ severity: 'error', summary: 'Error Message', detail: err });
          // this.activityRecordService.activityRecord(this.userId, 'Farmer Share to Farmer PFMS Export (ABY) lot Certificate', lotId, new Date(), err);
        }
      });
    }
  }

  getLotDetails(lotId){
    this.caoService.getAppsForLotDetailsEPC(lotId)
      .pipe(first())
      .subscribe({
        next: (data) => {
          // this.loader.close();
          this.loading1 = false;
          if (data?.length > 0) {
            this.appDataLotWise = data.map(val => ({
              ...val,
              totalCost85Per: (val?.TotalRecommendedAmt*0.85).toFixed(2)
            }));
            // this.appDataLotWise = this.appDataLotWise.map(row => ({
            //   ...row,
            //   AppId_ProgID: row.APP_ID.concat("_", row.ProgramID)
            // }))

            this.groupVendors(data);
            // this.filteredVendors = [...this.groupedVendors];

            const castCategoryList = [...new Set(data.map(item => item.Caste_Description))];

            this.casteDespList = castCategoryList.map(caste => ({
              label: caste,
              data: caste
            }));
          }
          else{
            this.appDataLotWise = [];
            this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'Data Not Available' });
          }
          // this.activityRecordService.activityRecord(this.userId, 'Subsidy To Vendor PFMS Export (PDMC)', lotId, new Date(), 'Success');
        },
        error: (err) => {
          this.appDataLotWise = [];
          // this.loader.close();
          this.loading1 = false;
          this.messageService.add({ severity: 'error', summary: 'Error Message', detail: err });
          // this.activityRecordService.activityRecord(this.userId, 'Subsidy To Vendor PFMS Export (PDMC)', lotId, new Date(), err);
        }
      });
  }

  onSelectCaste(){
    if(this.selectedCasteToFilter != null){
      let data = this.appDataLotWise.filter(item => item.Caste_Description === this.selectedCasteToFilter);
      this.groupVendors(data);
      
    }else if(this.selectedCasteToFilter == null){
      let data = this.appDataLotWise;
      this.groupVendors(data);
    }
  }

  onSelectSanction(){
    
    if(this.selectedSanctionToFilter != null){

    }
  }

  groupVendors(data): void {
    const vendorMap = new Map();
    
    data.forEach(item => {
      const vendorName = item.ContractorName;
      if (!vendorMap.has(vendorName)) {
        vendorMap.set(vendorName, {
          vendorName: vendorName,
          gstNo: item.GST,
          panNo: item.Vendor_Pan_Card_No,
          caoRemarks: item.CAORemarks,
          items: [],
          beneficiaryCount: 0, // Initialize beneficiary count
        });
      }
      const vendor = vendorMap.get(vendorName);
      vendor.items.push(item);
      vendor.beneficiaryCount = vendor.items.length; // Update beneficiary count
    });

    // If you want total vendor count, you can use:
    const vendorCount = vendorMap.size;
    
    this.groupedVendors = Array.from(vendorMap.values());
    this.filteredVendors = [...this.groupedVendors];
  }

  hideDialog(){
    this.addDialog = false;
    this.lotNo = null;
    this.appDataLotWise = [];
    this.miCertificateData = {};
    this.selectedSanctionToFilter = null;
    this.selectedCasteToFilter = null;
  }

   // Calculate total amount for a row
  calculateTotal(item: any): number {
    return (item.LotCentre_share_amt || 0) + 
           (item.LotLotState_share_amt || 0) + 
           (item.TopUp || 0);
  }

  // Vendor totals
  getVendorTotalArea(vendor: any): number {
    return vendor.items.reduce((sum: number, item: any) => sum + (item.TotalArea || 0), 0);
  }

  getVendorTotalFarmerShare(vendor: any): number {
    return vendor.items.reduce((sum: number, item: any) => sum + (item.FarmerShareAmt || 0), 0);
  }

  getVendorTotalCenterShare(vendor: any): number {
    return vendor.items.reduce((sum: number, item: any) => sum + (item.LotCentre_share_amt || 0), 0);
  }

  getVendorTotalStateShare(vendor: any): number {
    return vendor.items.reduce((sum: number, item: any) => sum + (item.LotLotState_share_amt || 0), 0);
  }

  getVendorTotalTopUp(vendor: any): number {
    return vendor.items.reduce((sum: number, item: any) => sum + (item.TopUp || 0), 0);
  }

  getVendorTotalAmount(vendor: any): number {
    return this.getVendorTotalCenterShare(vendor) + 
           this.getVendorTotalStateShare(vendor) + 
           this.getVendorTotalTopUp(vendor);
  }

  getSanctionWiseAmount(vendor: any): number {
    if(this.selectedSanctionToFilter == 'State_Center'){
      return this.getVendorTotalCenterShare(vendor) + this.getVendorTotalStateShare(vendor);
    }
    else if(this.selectedSanctionToFilter == 'Topup'){
      return this.getVendorTotalTopUp(vendor);
    }
  }

  // Grand totals
  getGrandTotalArea(): number {
    return this.filteredVendors.reduce((sum, vendor) => sum + this.getVendorTotalArea(vendor), 0);
  }

  getGrandTotalFarmerShare(): number {
    return this.filteredVendors.reduce((sum, vendor) => sum + this.getVendorTotalFarmerShare(vendor), 0);
  }

  getGrandTotalCenterShare(): number {
    return this.filteredVendors.reduce((sum, vendor) => sum + this.getVendorTotalCenterShare(vendor), 0);
  }

  getGrandTotalStateShare(): number {
    return this.filteredVendors.reduce((sum, vendor) => sum + this.getVendorTotalStateShare(vendor), 0);
  }

  getGrandTotalTopUp(): number {
    return this.filteredVendors.reduce((sum, vendor) => sum + this.getVendorTotalTopUp(vendor), 0);
  }

  getGrandTotalAmount(): number {
    return this.getGrandTotalCenterShare() + 
           this.getGrandTotalStateShare() + 
           this.getGrandTotalTopUp();
  }

  getGrandTotalSanctionWiseAmount(): number {
    if(this.selectedSanctionToFilter == 'State_Center'){
      return this.getGrandTotalCenterShare() + 
           this.getGrandTotalStateShare();
    }
    else if(this.selectedSanctionToFilter == 'Topup'){
      return this.getGrandTotalTopUp();
    }
  }

  // Grand total of beneficiaries across filtered vendors
  getGrandTotalBeneficiaries(): number {
    return this.filteredVendors.reduce((sum, vendor) => sum + (vendor?.beneficiaryCount || 0), 0);
  }


  pfmsExportExcel(modelData, filename) {
    // this.countNoOfTimesExported();
    import("xlsx").then(xlsx => {
      // Sheet 1: Vendor Data
      let sheetData = [];
      const itemHeaders = [
        'Sr. No.',
        'Lot No.',
        'Application No.',
        'Farmer Name',
        'Farmer Type',
        'Village',
        'Block',
        'District',
        'Caste Description',
        'MI Type',
        'MI Area',
        'Farmer Share',
        'Credited Date',
        'Center Share Payment',
        'State Share Payment',
        'Top Up',
        'Total Amount',
      ];

      let vendors = this.filteredVendors && this.filteredVendors.length ? this.filteredVendors : this.groupedVendors;
      vendors.forEach((vendor, idx) => {
        // push a bold-unicode version of the vendor line so it appears bold in Excel
        const toBoldUnicode = (s: string) =>
          s.replace(/[A-Za-z0-9]/g, (c) => {
            const code = c.charCodeAt(0);
            if (c >= 'A' && c <= 'Z') return String.fromCodePoint(0x1D400 + (code - 65));
            if (c >= 'a' && c <= 'z') return String.fromCodePoint(0x1D41A + (code - 97));
            if (c >= '0' && c <= '9') return String.fromCodePoint(0x1D7CE + (code - 48));
            return c;
          });

        sheetData.push({
          'Sr. No.': toBoldUnicode(`Vendor: ${vendor.vendorName}, GST No: ${vendor.gstNo}, PAN No: ${vendor.panNo}`),
        });
        let headerRow = {};
        itemHeaders.forEach(h => headerRow[h] = h);
        sheetData.push(headerRow);
        vendor.items.forEach(item => {
            sheetData.push({
            'Sr. No.': vendor.items.indexOf(item) + 1,
            'Lot No.': this.lotNo,
            'Application No.': item.APP_ID,
            'Farmer Name': item.Name,
            'Farmer Type': item.FarmerType,
            'Village': item.Village,
            'Block': item.Block,
            'District': item.District,
            'Caste Description': item.Caste_Description,
            'MI Type': item.ProposedSystem,
            'MI Area': item?.TotalArea,
            // 'Farmer Share': item?.FarmerShareAmt,
            'Credited Date': item?.CreditedOnDateTime ? item?.CreditedOnDateTime : '',
            'Center Share Payment': item.LotCentre_share_amt,
            'State Share Payment': item.LotLotState_share_amt,
            'Top Up': item.TopUp,
            'Total Amount': this.calculateTotal(item),
            });
        });
        sheetData.push({
          'Application No.': 'Vendor Totals',
          'MI Area': this.getVendorTotalArea(vendor),
          // 'Farmer Share': this.getVendorTotalFarmerShare(vendor),
          // 'Beneficiary (No.)': vendor.beneficiaryCount,
          'Center Share Payment': this.getVendorTotalCenterShare(vendor),
          'State Share Payment': this.getVendorTotalStateShare(vendor),
          'Top Up': this.getVendorTotalTopUp(vendor),
          'Total Amount': this.getVendorTotalAmount(vendor),
        });
        sheetData.push({});
      });
      // sheetData.push({
      //   'Application No': 'Grand Totals',
      //   'MI Area': this.getGrandTotalArea(),
      //   'Farmer Share': this.getGrandTotalFarmerShare(),
      //   'Beneficiary (No.)': this.getGrandTotalBeneficiaries(),
      //   'Center Share Payment Amount': this.getGrandTotalCenterShare(),
      //   'State Share Payment Amount': this.getGrandTotalStateShare(),
      //   'Top Up': this.getGrandTotalTopUp(),
      //   'Total Amount': this.getGrandTotalAmount(),
      // });

      // Add a blank row then vendor table as objects mapped to the existing itemHeaders
      sheetData.push([]);

      // Vendor Table Header (mapped to the same columns used in the sheet so the row appears from column A)
      sheetData.push({
        // 'Application No.': '',
        // 'Lot No.': '',
        // 'Farmer Name': '',
        'Farmer Type': this.miCertificateData?.Program_Name,
        // 'Application Type': '',
        // 'Caste Description': '',
      });

      sheetData.push({
        'Lot No.': 'Sr. No.',
        'Application No.': 'Vendor Name',
        'Farmer Name': 'Beneficiary (No.)',
        'Farmer Type': 'Center Share Payment Amount',
        'Village': 'State Mandetory Share Payment Amount',
        'Block': 'Top Up',
        'District': 'Total Amount'
      });

      // Vendor Table Body (each row mapped to the same first columns so data starts from the left)
      (this.groupedVendors || []).forEach((item, idx) => {
        sheetData.push({
          'Lot No.': idx + 1,
          'Application No.': item.vendorName,
          'Farmer Name': item.beneficiaryCount,
          'Farmer Type': this.getVendorTotalCenterShare(item),
          'Village': this.getVendorTotalStateShare(item),
          'Block': this.getVendorTotalTopUp(item),
          'District': this.getVendorTotalAmount(item)
        });
      });

      sheetData.push({
        'Lot No.': 'Total',
        'Application No.': '',
        'Farmer Name': this.getGrandTotalBeneficiaries(),
        'Farmer Type': this.getGrandTotalCenterShare(),
        'Village': this.getGrandTotalStateShare(),
        'Block': this.getGrandTotalTopUp(),
        'District': this.getGrandTotalAmount()
      });

      sheetData.push({ 'Sr. No.': `` });
      sheetData.push({ 'Sr. No.': `It is certified that : -` });
      sheetData.push({ 'Sr. No.': `1. The terms and conditions on the basis of which subsidy has proposed to be released have been fulfilled as per operational guidelines of PDMC scheme.` });
      sheetData.push({ 'Sr. No.': `2. MI system installed is as per approved specification based on area specified by Farmers in their application and within approved cost/ estimate.` });
      sheetData.push({ 'Sr. No.': `3. The benefit of scheme has extended to intended beneficiaries only one time and no payment were made earlier against these proposed application either to farmer or vendor.` });
      sheetData.push({ 'Sr. No.': `4. The cases are submitted for first time for release of assistance.` });
      sheetData.push({ 'Sr. No.': `5. The Farmer had deposited its 15% contribution as farmer share.` });
      sheetData.push({ 'Sr. No.': `6. All required documents from both the vendors and beneficiary have been verified and uploaded on MI Portal.` });
          

      const worksheet1 = xlsx.utils.json_to_sheet(sheetData, { skipHeader: true });

      // Sheet 2: Certificate/Sanction Letter
      let certData = [];
      // Header
      certData.push([``, ``, ``, `MICRO IRRIGATION COMPONENT`]);
      certData.push([``, ``, ``, `HARYANA`]);
      certData.push([``, ``, ``, `Financial Year: ${this.selectedYear || ''}`]);
      certData.push([]);
      certData.push([`Lot No. : ${this.lotNo}`, ``, ``, ``, ``, ``, `Date of Print Generated ${this.printGeneratedDate}` ]);
      certData.push([]);
      certData.push([``, ``, ``, `ORDER`]);
      certData.push([`Sanction is hereby accorded for disbursement of subsidy of Rs. ${ this.getGrandTotalAmount() || ''} on a/c of installation of Micro Irrigation System ${this.miCertificateData?.Program_Name || ''}`]);
      certData.push([`by the applicant farmer on farmer share basis to the registered vendors through E-Sparsh portal as per GOI instructions from Centrally sponsored scheme code ${this.miCertificateData?.CenterSponsoredScheme || ''}`]);
      certData.push([`and & State linked scheme code ${this.miCertificateData?.StateSponsoredScheme || ''}.`]);
      certData.push([]);
      certData.push([`Administrator MICADA been the competent authority had sanctioned the expenditure as per details under:`]);
      certData.push([]);
      // Vendor Table Header
      certData.push([`Sn.`, `Name of Payee`, `Particular`, `Lot No.`, `E-office No. & Dated`, `Beneficiary (No.)`, `Total`]);
      // Vendor Table Body
      (this.groupedVendors || []).forEach((item, idx) => {
        certData.push([
          idx + 1,
          item.vendorName,
          'Disbursement of Subsidy',
          this.lotNo,
          item.caoRemarks,
          item.beneficiaryCount,
          this.getSanctionWiseAmount(item)
        ]);
      });
      // Vendor Table Footer - beneficiary total + amount
      certData.push([`Total`, '', '', '', '', this.getGrandTotalBeneficiaries(), this.getGrandTotalSanctionWiseAmount()]);
      certData.push([]);
      certData.push([`The expenditure will be met out for the budget the head for F.Y. ${this.miCertificateData?.financialYear || ''}.`]);
      certData.push([`Implementation of Pradhan Mantri Krishi Sinchayee Yojana- Per Drop More Crop ${this.miCertificateData?.caste || ''} Under Head ${this.miCertificateData?.code || ''}.`]);
      certData.push([]);
      certData.push([]);
      certData.push([]);
      certData.push([``, ``, ``, ``, ``, ``, ``, `Engineer-in-Chief`]);
      certData.push([``, ``, ``, ``, ``, ``, ``, `Irrigation & W.R. Deptt.`]);
      certData.push([``, ``, ``, ``, ``, ``, ``, `Cum-Administrator, MICADA`]);
      certData.push([``, ``, ``, ``, ``, ``, ``, `Haryana (SNA-SPARSH)`]);
      certData.push([]);
      certData.push([`Endst. No./MICADA/ ${this.miCertificateData?.eNo || ''}`, ``, ``, ``, ``, ``, `Dated: ${this.miCertificateData?.date || ''}`]);
      certData.push([]);
      certData.push([`A copy is forwarded to the following for information and n/a please:`]);
      certData.push([`1. The Principal Accountant General (A&E), Haryana, Chandigarh.`]);
      certData.push([`2. Treasury Officer, Cyber Treasury, Panchkula.`]);
      certData.push([`3. Chief Accounts Officer, MICADA for making payment through E-Sparsh Portal. (Two copies)`]);
      certData.push([`4. Xen (Drainage) H.Q. Panchkula of Irrigation & Water Resources Dept. (SNA- Sparsh) being DDO (PDMC- PMKSY).`]);
      certData.push([]);
      certData.push([]);
      certData.push([]);
      certData.push([``, ``, ``, ``, ``, ``, ``,``, `Director (MI)`]);
      certData.push([``, ``, ``, ``, ``, ``, ``,``, `For Administrator`]);
      certData.push([``, ``, ``, ``, ``, ``, ``,``, `MICADA, Panchkula`]);

      const worksheet2 = xlsx.utils.aoa_to_sheet(certData);

      // Create workbook with two sheets
      const workbook = { Sheets: { 'Vendor Data': worksheet1, 'Sanction Certificate': worksheet2 }, SheetNames: ['Vendor Data', 'Sanction Certificate'] };
      const excelBuffer: any = xlsx.write(workbook, {
        bookType: "xlsx",
        type: "array"
      });
      this.saveAsExcelFile(excelBuffer, filename);
    });
  }
  
  // countNoOfTimesExported(){
  //   let reqBody = {
  //     lotType: 'STV',
  //     subLotType: '',
  //     lotNo: this.lotNo,
  //     userId: this.userId,
  //     network_Id: this.ipAddress,
  //     terminal_Id: this.ipAddress 
  //   }

  //   this.postCountExportDataFrequency(reqBody);
  // }

  // postCountExportDataFrequency(reqBody) {
  //   // this.loader.start();
  //   // this.loading = true;
  //   this.deptDashBoardService
  //     .postCountExportDataFrequency(reqBody)
  //     .pipe(first())
  //     .subscribe({
  //       next: (data) => {
  //         // this.loader.close();
  //         // this.loading = false;
  //         if(data.Result == 'Success'){
  //           this.messageService.add({
  //             severity: 'success',
  //             summary: 'Success',
  //             detail: data.Result,
  //           });
  //         }else {
  //           this.messageService.add({
  //             severity: 'info',
  //             summary: 'Status',
  //             detail: data.Result,
  //           });
  //         }
  //       },
  //       error: (err) => {
  //         // this.loader.close();
  //         // this.loading = false;
  //         this.messageService.add({
  //           severity: 'error',
  //           summary: 'Error Message',
  //           detail: err,
  //         });
  //       },
  //     });
  // }

  rowBackgroundColor(row) {
    if (row.PendingCompletedDays <= -3) {
      //red
      return '#ff8080';
    }else if (row.PendingCompletedDays == -1 || row.PendingCompletedDays == -2) {
      //orange
      return '#ffc966';
    }else if (row.PendingCompletedDays == 0) {
      //light green
      return '#99e699'
    }else return '#ffffff'; 
  }

  toISOLocal(d) {
    var z = n => ('0' + n).slice(-2);
    var off = d.getTimezoneOffset();
    off = Math.abs(off);

    return z(d.getDate()) + '/'
      + z(d.getMonth() + 1) + '/' +
      d.getFullYear();
  }

  saveAsExcelFile(buffer: any, fileName: string): void {
    import("file-saver").then(FileSaver => {
      let EXCEL_TYPE =
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
      let EXCEL_EXTENSION = ".xlsx";
      const data: Blob = new Blob([buffer], {
        type: EXCEL_TYPE
      });
      saveAs(
        data,
        fileName + "_export_" + new Date().getTime() + EXCEL_EXTENSION
      );
    });
  }
}
